import React from 'react';

import ErrorMessage from '../../../Shared/Components/ErrorMessage';

const Sep = ({ serverErrors, handleChange, errors, values }) => {
  return (
    <>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>ترمینال آی دی</label>
          <input
            type='text'
            className='form-control'
            value={values?.terminal_id}
            name='terminal_id'
            onChange={handleChange}
          />
          <ErrorMessage
            error={
              serverErrors?.terminal_id
                ? serverErrors.terminal_id
                : errors?.terminal_id
            }
          />
        </div>
      </div>
      <div className='col-12 col-md-6'>
        <div className='form-group'>
          <label className='form-label'>آدرس بازگشت از درگاه</label>
          <input
            type='text'
            className='form-control'
            value={values?.callback_url}
            name='callback_url'
            onChange={handleChange}
          />
          <ErrorMessage
            error={
              serverErrors?.callback_url
                ? serverErrors.callback_url
                : errors?.callback_url
            }
          />
        </div>
      </div>
    </>
  );
};

export default Sep;
